exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-45d6c032]{width:1050px;margin:50px auto;border:1px solid #eee}.bor_style[data-v-45d6c032]:not(:last-child){margin-left:-18px;margin-right:-18px;border-bottom:1px solid #eadadd}.link_a[data-v-45d6c032]{border-bottom:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-45d6c032","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/brand_supple_agree/supple_brand_agree.vue
// module id = 373
// module chunks = 0